import axios from 'axios';

const registryAxios = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

export const REGISTRY_GROUPS = [
    { value: 'templates', label: 'Шаблоны' },
    { value: 'classifiers', label: 'Классификаторы' },
    { value: 'regulations', label: 'Регламенты' },
];

const registryApi = {
    uploadFiles: (group, files, userEmail) => {
        const formData = new FormData();
        formData.append('group', group);
        formData.append('userEmail', userEmail);

        Array.from(files).forEach((file) => {
            formData.append('file', file);
        });

        return registryAxios.post('/v2/registry/upload', formData);
    },

    listFiles: (group, userEmail) => registryAxios.get('/v2/registry/list', {
        params: { group, userEmail },
    }),

    deleteFile: (group, fileName, userEmail) => registryAxios.delete('/v2/registry/file', {
        data: { group, userEmail, fileName },
    }),
};

export default registryApi;
